// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputWithLabel_inputContainer__FDXKi","icon":"InputWithLabel_icon__F0YNE"};